/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for A+ Content Management
 * Use the A+ Content API to build applications that help selling partners add rich marketing content to their Amazon product detail pages. Selling partners can use A+ content to share their brand and product story, which helps buyers make informed purchasing decisions. Selling partners use content modules to add images and text.
 *
 * The version of the OpenAPI document: 2020-11-01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * A flag that provides additional information about an ASIN. This is contextual and can change depending on the request that generated it.
 */

export const AsinBadge = {
    BrandNotEligible: 'BRAND_NOT_ELIGIBLE',
    CatalogNotFound: 'CATALOG_NOT_FOUND',
    ContentNotPublished: 'CONTENT_NOT_PUBLISHED',
    ContentPublished: 'CONTENT_PUBLISHED',
} as const;

export type AsinBadge = typeof AsinBadge[keyof typeof AsinBadge];



